import $ from 'cash-dom';
import Ajax from './ajax';
import spinner from './spinner';
import Popup from './popup';

$(function () {
	let pathPartsCache = null;
	const postId = $('body').data('post-id');
	const $loadMoreContainer = $('.load-more-container');
	const $categoriesList = $('.categories-list');
	const pageType = $('#page-type').val();
	const pathname = getBasePathname();
	//a bio page loads more in place: the URL stays, and the loader sits where the link was
	const inPlace = pageType === 'AuthorPage';
	let currentPage = getCurrentPage();

	$('.load-more').on('click', function (e) {
		e.preventDefault();

		if ($loadMoreContainer.hasClass('is-loading')) {
			return;
		}

		const page = currentPage + 1;

		if (inPlace) {
			$loadMoreContainer.addClass('is-loading');
		} else {
			spinner.show();
		}

		Ajax.post(ajaxurl, {
			action: 'load-directory-data',
			postId: postId,
			page: page,
			pageType: pageType,
			authorId: $('#author-id').val(),
		}, function (response) {
			if (response && response.html) {
				currentPage = page;

				if (!inPlace) {
					let currentPath = pathname + 'page/' + page + '/';

					history.replaceState({page: page}, '', currentPath);

					$('link[rel="canonical"]').attr('href', window.location.origin + currentPath);
				}

				if (pageType === 'BlogsPage') {
					$('.blogposts-list').append(response.html);
				} else {
					$categoriesList.append(response.html);
				}

				if (!response.showLoadMore) {
					$loadMoreContainer.hide();
				}
			}
		}, 'json').fail(function () {
			const popup = new Popup();
			popup.show(tr('Sorry, some error occurred. Please, try again later.'));
		}).always(function () {
			$loadMoreContainer.removeClass('is-loading');
			spinner.hide();
		});
	});


	function getBasePathname() {
		const pathParts = getPathParts();

		const secondToLastIndex = pathParts.length - 2;
		const secondToLastPart = pathParts[secondToLastIndex] || null;

		const partsToGetBasename = secondToLastPart === 'page'
			? pathParts.slice(0, secondToLastIndex)
			: pathParts;

		const basePathname = partsToGetBasename.join('/');

		return '/' + basePathname + '/';
	}

	function getPathParts() {
		if (pathPartsCache === null) {
			const url = new URL(window.location.href);
			pathPartsCache = url.pathname.replace(/^\/|\/$/g, '').split('/');
		}

		return pathPartsCache;
	}

	function getCurrentPage() {
		const url = new URL(window.location.href);
		const pathParts = url.pathname.split('/');

		let page = 1;

		for (let i = pathParts.length; i > 0; --i) {
			if (pathParts[i] === 'page' && pathParts[i + 1]) {
				page = pathParts[i + 1];
				break;
			}
		}

		return Number.parseInt(page);
	}
});
